// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__17DlT","header":"PatientBlock_header__W5gi5","label":"PatientBlock_label__2mXj-","option":"PatientBlock_option__1DsJM"};